<div class="loader1 dot-spin"></div>

<div class="overlay" *ngIf="!hideOverlay"></div>
